import { flow, types, applySnapshot } from 'mobx-state-tree';

import api from '../utils/api';

const Item = types.optional(types.map(types.frozen), {});

const MapsStore = types
  .model('Maps', {
    items: types.array(Item),
  })
  .actions(self => ({
    load: flow(function* load() {
      const response = yield api.maps();
      applySnapshot(self.items, yield response.json());
    }),
  }));

export default MapsStore;



// WEBPACK FOOTER //
// ./src/stores/MapsStore.js